export const emailSampleLink = "https://www.brandgen.io/hubfs/Help%20Documents/BG_Sample_Emails.csv";
export const domainSampleLink = "https://www.brandgen.io/hubfs/Help%20Documents/BG_Sample_Domains.csv";
